import { ISelectorOptions } from 'components/common'
import { BannerType } from 'generated/graphql'

export const BannerTypeValues: ISelectorOptions = [
  { value: BannerType.MainPageWide, label: 'Main Page Wide' },
]
